import { useUnleashContextStatus } from "./UnleashContextSync";

export type AdvancedTradingDashboardAccessStatus =
  | "pending"
  | "allowed"
  | "denied"
  | "unavailable";

export const useAdvancedTradingDashboardAccess =
  (): AdvancedTradingDashboardAccessStatus => {
    const {
      isSynchronized,
      hasSynchronizationError,
      isAdvancedTradingDashboardEnabled,
    } = useUnleashContextStatus();

    if (hasSynchronizationError) {
      return "unavailable";
    }
    if (!isSynchronized) {
      return "pending";
    }
    if (!isAdvancedTradingDashboardEnabled) {
      return "denied";
    }
    return "allowed";
  };
